export const iconFontAwesomeEducationLaptopFile = (
	<i className="fa-solid fa-laptop-file"></i>
);
